import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMenosTalentosService } from "../../../../services/dashboard/menosTalentos/menosTalentos.services";

export const getMenosTalentosThunk = createAsyncThunk(
  "menosTalentos/getMenosTalentos",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { escuela, plantel } = getState().dashboardFilters;
      return await getMenosTalentosService({ escuela, plantel });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error obteniendo talentos a mejorar"
      );
    }
  }
);
